import { Navigate, useLocation } from "react-router-dom";

import { useAuth } from "services/Auth/AuthContext";

const RequireAuth = ({ children }) => {
  const auth = useAuth()
  const location = useLocation()

  return auth.user ? children : (
    // Redirect them to the /login page, but save the current location they were
    // trying to go to when they were redirected. This allows us to send them
    // along to that page after they login, which is a nicer user experience
    // than dropping them off on the home page.
    <Navigate
      to='/login' state={{ from: location }}
      replace
    />
  )
}

export default RequireAuth
